enum CertificatePreviewGenerateTypes {
  RABIES = 'RABIES',
  PROOF_OF_VACCINATIONS = 'PROOF_OF_VACCINATIONS',
}

export default CertificatePreviewGenerateTypes
